<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M0 -0.445557H1.75916V14.4455H0V-0.445557Z" fill="currentColor"/>
      <path d="M9.92188 5.67407H11.9622V7.71444H9.92188V5.67407Z" fill="currentColor"/>
      <path d="M7.88281 3.63379H9.92318V5.67416H7.88281V3.63379Z" fill="currentColor"/>
      <path d="M5.83984 5.67407H7.88021V7.71444H5.83984V5.67407Z" fill="currentColor"/>
      <path d="M7.88281 -0.445557H9.92318V1.59339H7.88281V-0.445557Z" fill="currentColor"/>
      <path d="M1.76172 5.67407H3.80153V7.71444H1.76172V5.67407Z" fill="currentColor"/>
      <path d="M3.80078 7.71448H5.84112V9.75485H3.80078V7.71448Z" fill="currentColor"/>
      <path d="M7.88281 7.71448H9.92318V9.75485H7.88281V7.71448Z" fill="currentColor"/>
      <path d="M1.76172 1.59351H3.80153V3.63388H1.76172V1.59351Z" fill="currentColor"/>
      <path d="M3.80078 -0.445557H5.84115V1.59339H3.80078V-0.445557Z" fill="currentColor"/>
      <path d="M9.92188 1.59351H11.9622V3.63388H9.92188V1.59351Z" fill="currentColor"/>
      <path d="M5.83984 1.59351H7.88021V3.63388H5.83984V1.59351Z" fill="currentColor"/>
      <path d="M3.80078 3.63379H5.84115V5.67416H3.80078V3.63379Z" fill="currentColor"/>
      <path d="M14.0013 3.63379H11.9609V5.67416H14.0024L14.0013 3.63379Z" fill="currentColor"/>
      <path d="M14.0024 -0.445557H11.9609V1.59339H14.0013L14.0024 -0.445557Z" fill="currentColor"/>
      <path d="M14.0024 7.71448H11.9609V9.75485L14.0024 9.75575V7.71448Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="14" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
name: "IconFlag"
}
</script>

<style scoped>

</style>